import React from 'react';
import { Tabs } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import SpecBottomSheet from '../SpecBottomSheet/SpecBottomSheet';
import './DirectorySearch.css';

interface DirectorySearchContentProps {
  activeTab: 'shows' | 'bands' | 'musicians' | 'venues';
  onTabChange?: (key: string) => void;
}



interface DirectorySearchProps extends DirectorySearchContentProps {
  asBottomSheet?: boolean;
  open?: boolean;
  onClose?: () => void;
}

const DIRECTORY_PAGES = ['/shows', '/bands', '/musicians', '/venues'];

const DirectorySearchContent: React.FC<DirectorySearchContentProps> = ({ 
  activeTab, 
  onTabChange 
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleTabChange = (key: string) => {
    if (onTabChange) {
      onTabChange(key);
    } else {
      const targetPath = `/${key}`;
      const isCurrentDirectory = DIRECTORY_PAGES.includes(location.pathname);
      const isTargetDirectory = DIRECTORY_PAGES.includes(targetPath);
      
      if (isCurrentDirectory && isTargetDirectory) {
        navigate(targetPath, { replace: true });
      } else {
        navigate(targetPath);
      }
    }
  };

  return (
    <div className="directory-search-container">
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        items={[
          { key: 'shows', label: 'Shows' },
          { key: 'bands', label: 'Bands' },
          { key: 'musicians', label: 'Musicians' },
          { key: 'venues', label: 'Venues' },
        ]}
      />
    </div>
  );
};

export const DirectorySearch: React.FC<DirectorySearchProps> = ({ 
  activeTab,
  asBottomSheet = false,
  open = false,
  onClose = () => {},
  ...props
}) => {
  if (asBottomSheet) {
    return (
      <SpecBottomSheet open={open} onClose={onClose} showHandle={true}>
        <DirectorySearchContent 
          activeTab={activeTab} 
          {...props}
        />
      </SpecBottomSheet>
    );
  }

  return (
    <DirectorySearchContent 
      activeTab={activeTab} 
      {...props}
    />
  );
};
